import {actionTypes} from '../action/action';

interface contactSate {
  UA: any;
  prevUserAgent:any;
}
const initialState = {
  UA:{},
  prevUserAgent:[]
};

export const userAgent = (state:contactSate  = initialState, action: any) => {
  const {
    type,
    payload
  } = action;
  switch (type) {
  case actionTypes.CREATE_CALL_UA:
    return {
      ...state, UA: payload
    };

  case actionTypes.MULTI_INVITE_CHECK:
      return {
        ...state, prevUserAgent: payload
      };
  default:
    return state;
  };
};
